import React from 'react';
import PropTypes from 'prop-types';
import { Box, colors } from '@procore/core-react';
import styled from 'styled-components';

const OverlayContainer = styled(Box)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${colors.white};
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: ${({ isOpen }) => (isOpen ? 'scale(1)' : 'scale(0.8)')};
  transform-origin: bottom center;
  transition:
    opacity 0.15s ease,
    transform 0.25s ease;
  z-index: 10001;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
`;

const ContentWrapper = styled(Box)`
  background-color: ${colors.white};
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MobileOverlay = ({ isOpen, children, testId = 'mobile-overlay' }) => {
  return (
    <OverlayContainer isOpen={isOpen} data-testid={testId}>
      <ContentWrapper>{children}</ContentWrapper>
    </OverlayContainer>
  );
};

MobileOverlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string,
};

export { MobileOverlay };
